import { render } from "./FnColumnSettings.vue?vue&type=template&id=a7cb1bba"
import script from "./FnColumnSettings.vue?vue&type=script&lang=js"
export * from "./FnColumnSettings.vue?vue&type=script&lang=js"

import exportComponent from "e:\\AiGreate\\tmp\\vertex\\webui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__